import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Col,
  Card,
  Modal,
  message,
  Row,
  Breadcrumb,
  Space,
  Typography,
  Collapse,
} from "antd";
import axios from "axios";
import moment from "moment";
import { DownloadOutlined, CaretRightOutlined } from "@ant-design/icons";

import { usePermissions } from "../App/PermissionContext";
import { EXPORT_LABELS } from "../../constants/exports";
import { PERMISSIONS } from "../../constants/roles";

import "react-vis/dist/style.css";
import ExportFilters from "./ExportFilters";
const today = moment();
const threeMonthsAgo = moment().subtract(3, "months");

const Export = () => {
  const { permissions } = usePermissions();

  const [isDownloading, setIsDownloading] = useState(false);
  const [filters, setFilters] = useState({});

  const downloadSenderAddress = async () => {
    setIsDownloading(true);
    let total;
    const dateParams = {
      startDate: filters.startDate?.startOf("month")?.toISOString(),
      endDate: filters.endDate?.endOf("month")?.toISOString(),
    };
    await axios
      .get("/api/addresses", {
        params: { ...dateParams },
      })
      .then((res) => {
        total = res.data.pagination.totalSize;
      });
    const messageContent = (
      <p>
        Are you sure you want to download {total} Sender Address Info data ?
        <br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Sender Address List ? `,
      async onOk() {
        await axios
          .get("/api/address/csv", {
            params: { ...dateParams },
          })
          .then((res) => {
            message.info(`Please check your email after 5-20 minute`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
    setIsDownloading(false);
  };
  const downloadReceiverAddress = async () => {
    setIsDownloading(true);
    let total;
    const dateParams = {
      startDate: filters.startDate?.startOf("month")?.toISOString(),
      endDate: filters.endDate?.endOf("month")?.toISOString(),
    };
    await axios
      .get("/api/client-addresses", {
        params: { ...dateParams },
      })
      .then((res) => {
        total = res.data.pagination.totalSize;
      });
    const messageContent = (
      <p>
        Are you sure you want to download {total} Receiver Address data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Receiver Address List ? `,
      async onOk() {
        await axios
          .get("/api/clientAddress/csv", {
            params: { ...dateParams },
          })
          .then((res) => {
            message.info(`Please check your email after 5-20 minute`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
    setIsDownloading(false);
  };

  const downloadRiderInfo = async () => {
    setIsDownloading(true);
    let total;
    const dateParams = {
      startDate: filters.startDate?.startOf("month")?.toISOString(),
      endDate: filters.endDate?.endOf("month")?.toISOString(),
    };
    await axios
      .get("/api/riderInfo/count", {
        params: { ...dateParams },
      })
      .then((count) => {
        total = count.data.count;
        console.log("HERE", total);
      });
    const messageContent = (
      <p>
        Are you sure you want to download {total} Rider Info data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Rider Info List ? `,
      async onOk() {
        await axios
          .get("/api/riderInfo/csv", {
            params: { ...dateParams },
          })
          .then((res) => {
            message.info(`Please check your email after 5-20 minute`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
    setIsDownloading(false);
  };

  const downloadAllUserCSV = async () => {
    const queryString = new URLSearchParams(filters).toString();

    const messageContent = (
      <p>
        Are you sure you want to download user data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download User List ? `,
      async onOk() {
        await axios
          .get(`/api/users/csv?${queryString}`, {
            extraInfo: true,
          })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
  };

  const downloadProfitCSV = async () => {
    const dateParams = {
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
    };

    const messageContent = (
      <p>
        Are you sure you want to download profit data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Profit List ? `,
      async onOk() {
        await axios
          .get(`/api/merchant-profit/export-daily`, {
            params: {
              ...dateParams
            },
          })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.response.data.message || error.message);
          });
      },
    });
  };

  const downloadTopupReport = async () => {
    setIsDownloading(true);
    let total;
    const dateParams = {
      startBeforeDate: filters.startBeforeDate?.startOf("month")?.toISOString(),
      endBeforeDate: filters.endBeforeDate?.endOf("month")?.toISOString(),
      startAfterDate: filters.startAfterDate?.startOf("month")?.toISOString(),
      endAfterDate: filters.endAfterDate?.endOf("month")?.toISOString(),
    };

    const messageContent = (
      <p>
        Are you sure you want to download Topup Report data ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download Topup Report ? `,
      async onOk() {
        await axios
          .get("/api/export-merhant-topup", {
            params: { ...dateParams },
          })
          .then((res) => {
            message.info(`Please check your email after 5-20 minute`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
    setIsDownloading(false);
  };

  const downloadDailyUserLoginReport = async () => {
    const dateParams = {
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
    };

    const messageContent = (
      <p>
        Are you sure you want to download user daily log ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download User List ? `,
      async onOk() {
        await axios
          .get(`/api/user-logs/daily-login-at`, {
            params: {
              description: "userLogIn",
              ...dateParams
            },
          })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
  };

  const downloadUserOrderReport = async () => {
    const dateParams = {
      startDate: filters.startDate?.startOf("day")?.toISOString(),
      endDate: filters.endDate?.endOf("day")?.toISOString(),
    };

    const messageContent = (
      <p>
        Are you sure you want to download user order report ?<br />
      </p>
    );

    Modal.confirm({
      content: messageContent,
      title: `Download User Order Report ? `,
      async onOk() {
        await axios
          .get(`/api/user-order/csv`, {
            params: {
              ...dateParams
            },
          })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });
  };

  const isTopupReportFiltersValid = () =>
    filters.startBeforeDate &&
    filters.endBeforeDate &&
    filters.startAfterDate &&
    filters.endAfterDate;

  return (
    <Space direction="vertical" style={{ display: "flex" }}>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">Export</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb style={{ margin: "10px 0", textAlign: "right" }} />
          </Col>
        </Row>
      </div>

      {permissions.includes(PERMISSIONS.EXPORT_SENDER_ADDRESS) && (
        <div>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="Sender Address" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
                label={EXPORT_LABELS.CREATED_AT}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadSenderAddress}>
                    Download Sender Address CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_RECEIVER_ADDRESS) && (
        <div>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="Receiver Address" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
                label={EXPORT_LABELS.CREATED_AT}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadReceiverAddress}>
                    Download Receiver Address CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_RIDER_INFO) && (
        <div>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="Rider Info" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadRiderInfo}>
                    Download Rider Info CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_USER_LIST) && (
        <div>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="User Details Report" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
                label={EXPORT_LABELS.REGISTERED_ON}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadAllUserCSV}>
                    Download User Details Report CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_PROFIT_REPORT) && (
        <>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="Profit Report" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
                label={EXPORT_LABELS.PROFIT_DATE}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadProfitCSV}>
                    Download Profit Report CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Collapse.Panel header="Daily Login User" key="senderFilters">
              <ExportFilters
                filters={filters}
                onFiltersChange={(filters) => setFilters(filters)}
                label={EXPORT_LABELS.LAST_LOGIN_AT}
              />
              <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                  <Button type="primary" onClick={downloadDailyUserLoginReport}>
                    Download Login User CSV <DownloadOutlined />
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_TOPUP_REPORT) && (
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
        >
          <Collapse.Panel header="Topup Report" key="senderFilters">
            <ExportFilters
              filters={filters}
              onFiltersChange={(filters) => setFilters(filters)}
              type="topup"
            />
            <Row justify="end" style={{ marginTop: 16 }}>
              <Col>
                <Button
                  type="primary"
                  onClick={downloadTopupReport}
                  disabled={!isTopupReportFiltersValid()}
                >
                  Download Topup Report CSV <DownloadOutlined />
                </Button>
              </Col>
            </Row>
          </Collapse.Panel>
        </Collapse>
      )}

      {permissions.includes(PERMISSIONS.EXPORT_USER_ORDER) && (
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
        >
          <Collapse.Panel header="User Order Report" key="senderFilters">
            <ExportFilters
              filters={filters}
              onFiltersChange={(filters) => setFilters(filters)}
            />
            <Row justify="end" style={{ marginTop: 16 }}>
              <Col>
                <Button type="primary" onClick={downloadUserOrderReport}>
                  Download User Order Report CSV <DownloadOutlined />
                </Button>
              </Col>
            </Row>
          </Collapse.Panel>
        </Collapse>
      )}
    </Space>
  );
};

export default Export;
